export default {
  en: {
    contactPerson: 'Contact Person',
    newContactPerson: 'New Contact Person',
    title: 'Title',
    firstName: 'First Name',
    lastName: 'Last Name',
    position: 'Position',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    addEmail: 'Add Email',
    addMobile: 'Add Mobile',
    create: 'Create Contact Person',
    cancel: 'Cancel',
    createContactPersonSuccessTitle: 'Success',
    createContactPersonSuccessMessage: 'Create Contact Person Success.'
  },
  th: {
    contactPerson: 'ผู้ติดต่อ',
    newContactPerson: 'สร้างผู้ติดต่อ',
    title: 'คำนำหน้า',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    position: 'ตำแหน่ง',
    phone: 'โทรศัพท์',
    mobile: 'มือถือ',
    fax: 'แฟกซ์',
    email: 'อีเมล',
    addEmail: 'เพิ่มอีเมล',
    addMobile: 'เพิ่มมือถือ',
    create: 'สร้างผู้ติดต่อ',
    cancel: 'ยกเลิก',
    createContactPersonSuccessTitle: 'สำเร็จ',
    createContactPersonSuccessMessage: 'สร้างผู้ติดต่อใหม่สำเร็จ'
  }
}
